module.exports = __webpack_public_path__ + "static/media/SubmittedOne.181b5910.png";